import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage';
import Template from './Pages/Template';
import ContentEngine from './Pages/ContentEngine';
import TemplateV1 from './Pages/TemplateV1';
import WorkflowConfigEditor from './Pages/WorkflowConfigEditor';
import appConfig from './Config/appConfig';
import { LanguageProvider } from './Context/LanguageContext';

function NotFoundPage() {
  return <h1>404 - Page Not Found</h1>;
}

function App() {
  const isDevelopment = appConfig.TestMode === 'TRUE' || process.env.NODE_ENV === 'development';
  return (
  
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {isDevelopment && (
            <>
              <Route path="/templatev2" element={<Template />} />
              <Route
                path="/content"
                element={
                  <LanguageProvider>
                    <ContentEngine />
                  </LanguageProvider>
                }
              />
              <Route path="/template" element={<TemplateV1 />} />
              <Route path="/workflow-config" element={<WorkflowConfigEditor />} />
            </>
          )}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
 
  );
}

export default App;
